<template lang="pug">
div
    BreadCrumb(:linkBreadCrumb="linkBreadCrumb")
    CrudForm(
        v-bind="staticData"
        :fields="fields"
        :customRules="customRules"
        @submitForm="handleSubmit($event)"
        :editable="$can('EDIT_PRODUCT_SUBFAMILY')"
        :readOnly="!$can('EDIT_PRODUCT_SUBFAMILY')"
        :noButtons="!$can('EDIT_PRODUCT_SUBFAMILY')"
        )
    v-text-field
    CrudCreateButton(
        text="Descuentos al por mayor"
        icon="local_offer"
        :buttonProps="{ color:'info', dark: true}"
        :action="editWholesaleDiscounts"
        
        )
</template>

<script>
import {
    CrudForm,
    BreadCrumb,
    CrudCreateButton,
} from '@/components/reusable_components'
import InputValidations from '@/mixins/InputValidations.js'
import CurrencyUtils from '@/mixins/CurrencyUtils.js'
import RUTInput from '@/components/RUTInput/RUTInput'
import SubfamilyService from '@/services/api/subfamily/SubfamilyService'
import WholesaleDiscountRoute from '@/mixins/WholesaleDiscountRoute'
import { addRUTHyphen, removeRUTHyphen } from '@/services/RUTFormatter'
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            formData: {},
            form: null,
            fields: [
                {
                    field: 'subfamily',
                    type: 'text',
                    maxLength: 30,
                    value: '',
                    vuetifyProps: {
                        label: 'Nombre de Subfamilia',
                    },
                    rules: ['required'],
                },
            ],
            //titulo
            staticData: null,

            customRules: {
                minLength8: function(value) {
                    return value.length >= 8 ? true : 'El largo mínimo es 8'
                },
            },
            arrCommunes: null,
            linkBreadCrumb: [
                {
                    text: 'Listado Familias',
                    disabled: false,
                    to: `/families`,
                    exact: true,
                },
                {
                    text: 'Familia',
                    disabled: false,
                    to: `/families/${this.$route.params.id}`,
                    exact: true,
                },
                {
                    text: 'Subfamilia',
                    disabled: true,
                },
            ],
        }
    },
    computed: {
        myFields() {
            return this.fields
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        async handleSubmit(event) {
            this.formData = event
            await this.sendUpdateSubfamily(this.formData)
        },
        async sendUpdateSubfamily(data) {
            let response = await SubfamilyService.updateSubfamily(
                this.$route.params.id_subfamily,
                data.subfamily
            )
            if (response.status == 'success') {
                //TODO: add snack
                let snackInfo = this.fillSnack(
                    'success',
                    'Éxito',
                    'Subfamilia editada exitosamente',
                    false,
                    3000
                )
                this.initSnackbar(snackInfo)
                this.$router.push({
                    path: `/families/${this.$route.params.id}`,
                })
            }
        },
        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Subfamilia'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return value.length >= 8 ? true : 'El largo mínimo es 8'
            }
            information.editable = true
            information.disabled = false
            information.submitText = 'Editar Subfamilia'

            return information
        },
        async fillFields() {
            let customerInfo = await SubfamilyService.fetchSubfamily(
                this.$route.params.id_subfamily
            )

            this.fields[0].value = customerInfo.subfamily

            this.fields = JSON.parse(JSON.stringify(this.fields))
        },
    },
    watch: {},
    components: { CrudForm, RUTInput, CrudCreateButton, BreadCrumb },
    mixins: [InputValidations, CurrencyUtils, WholesaleDiscountRoute],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function() {
        this.staticData = this.fillStaticFormData()
        this.fillFields()
        this.setTitleTopBar('Subfamilia')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PRODUCT_SUBFAMILY'))
                ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>